import { useProjectsStore } from '@modules/projects/stores/projects.store'
import { getCurrentProject } from '@modules/projects/stores/projects.thunks'
import { updateLastUsedProject } from '@modules/workspaces/stores/workspaces.thunks'
import type { Workspace } from '@modules/workspaces/workspaces.type'

function shouldQueueLastUsedSync(workspace: Workspace, currentProjectId: string | undefined): boolean {
  if (currentProjectId != null) {
    return workspace.lastUsedProjectId !== currentProjectId
  }
  return Boolean(workspace.lastUsedProjectId)
}

/**
 * Resolves the current project for the workspace, then queues a non-blocking last-used sync when needed.
 */
export async function resolveWorkspaceProjectAndSyncLastUsed(workspace: Workspace): Promise<void> {
  await getCurrentProject(workspace.workspaceId)

  const currentProject = useProjectsStore.getState().currentProject
  const projectIdToPersist = currentProject?.projectId ?? workspace.lastUsedProjectId
  if (!projectIdToPersist) {
    return
  }

  if (shouldQueueLastUsedSync(workspace, currentProject?.projectId)) {
    updateLastUsedProject(workspace.workspaceId, projectIdToPersist)
  }
}
